<div class="mb-3">
    @if (isReadOnly) {
        <div>
            @if (label != null) {
                <label>{{ label }}</label>
            }
            @if (showRequired) {
                <span class="required-indicator">*</span>
            }
            <input readonly="true" type="text" id="{{ id }}" class="form-control" [value]="readOnlyData" />
        </div>
    }
    @if (!isReadOnly) {
        <div>
            @if (label != null) {
                <label>{{ label }}</label>
            }
            @if (showRequired) {
                <span class="required-indicator">*</span>
            }
            <div class="ui-fluid">
                <p-datepicker
                    [showTime]="showTime"
                    [showIcon]="true"
                    [formControl]="control"
                    [minDate]="minimumDate"
                    [maxDate]="maximumDate"
                    dateFormat="dd/mm/yy"
                    [readonlyInput]="readonlyInput"
                    [selectionMode]="selectionMode"
                    [showButtonBar]="showButtonBar"
                    [appendTo]="appendTo"
                    [fluid]="true"
                ></p-datepicker>
            </div>
            @if (control.invalid) {
                <span class="help-block">
                    <span class="required-indicator">
                        {{ getErrorMessage() }}
                    </span>
                </span>
            }
        </div>
    }
</div>
